import React from 'react';
import { AlertCircle } from 'lucide-react';
import type { Workflow } from '@/content/workflows';
import { cn } from '@/lib/utils';

/** Sample output card for a workflow. Shared by the homepage selector and /use-cases. */
const WorkflowPreview = ({ workflow, className }: { workflow: Workflow; className?: string }) => (
  <div className={cn('border border-rule bg-knightblack/70', className)}>
    <div className="flex items-center justify-between border-b border-rule px-4 py-2.5">
      <span className="meta-label">Sample output</span>
      <span className="eyebrow">{workflow.sample.title}</span>
    </div>
    <dl className="divide-y divide-rule/70">
      {workflow.sample.lines.map((line) => (
        <div key={line.label} className="grid grid-cols-[8.5rem_1fr] gap-3 px-4 py-3 text-sm">
          <dt className="text-mist">{line.label}</dt>
          <dd className={cn('flex items-start gap-1.5', line.flag ? 'text-goldcore' : 'text-softwhite')}>
            {line.flag && <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-label="Flagged" />}
            {line.value}
          </dd>
        </div>
      ))}
    </dl>
  </div>
);

export default WorkflowPreview;
